<template>
  <div>
    <div class="pa-1">
      <div style="font-size: 16px; font-weight: 600" class="mb-3 primary--text">
        {{ $t('Purchase by Shop') }}
      </div>
      <template>
        <v-data-table :headers="headers" :items="purchaseByShopData" :pagination.sync="pagination">
          <template v-slot:items="props">
            <tr @click="showDetails(props.item.shop_via)" style="cursor: pointer">
              <td>{{ props.item.shop_via }}</td>
              <td class="text-left">{{ props.item.total }}</td>
              <td class="text-left">
                {{ parseFloat((props.item.total * 100) / totalQtyPurchase).toFixed(2) }} %
              </td>
            </tr>
          </template>
        </v-data-table>
      </template>

      <!-- Modal Details -->
      <v-dialog persistent width="950px" v-model="purchaseShopDetailsModal">
        <v-card v-if="purchaseShopDetailsModal">
          <PurchaseByShopDetailsModal
            @close="purchaseShopDetailsModal = false"
            :shop="selectedShopData"
            :selectedDate="selectedDate"
          ></PurchaseByShopDetailsModal>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import api from '@/api'
import moment from 'moment'
import PurchaseByShopDetailsModal from './PurchaseByShopDetailsModal.vue'

export default {
  props: ['selectedDate', 'filter'],
  data: function () {
    return {
      pagination: {
        rowsPerPage: 10
      },
      loading: false,
      purchaseByShopData: [],
      purchaseShopDetailsModal: false,
      selectedShopData: null,
      totalQtyPurchase: 0,
      headers: [
        { text: 'Shop', value: 'shop_via' },
        { text: 'Count', value: 'total' },
        { text: '%', value: 'total' }
      ]
    }
  },
  components: {
    PurchaseByShopDetailsModal
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      currentLang: 'currentLang'
    })
  },
  mounted: function () {
    this.getPurchaseByShop()
  },
  methods: {
    getPurchaseByShop() {
      var vm = this
      var data = {
        pageid: vm.selectedBot.pageid, // required
        start_date: moment(vm.selectedDate.start).format('YYYY-MM-DD'), // YYYY-MM-DD
        end_date: moment(vm.selectedDate.end).format('YYYY-MM-DD') // YYYY-MM-DD
      }
      vm.loading = true
      api.getLamyOverview2PurchaseByShop(data, (err, response) => {
        if (response.responsecode == 200) {
          vm.purchaseByShopData = response.data

          var count = 0

          $.each(response.data, function (index, val) {
            count += parseInt(val.total)
          })

          vm.totalQtyPurchase = count

          vm.$emit('dataPurchaseShop', response.data)
          vm.loading = false
        } else {
          console.log(err)
          return
        }
      })
    },
    showDetails(shop) {
      var vm = this
      vm.selectedShopData = shop
      vm.purchaseShopDetailsModal = true
    }
  },
  watch: {
    loading: function () {},
    selectedDate: {
      handler: function (newValue) {
        this.getPurchaseByShop()
      },
      deep: true
    },
    filter: function () {
      this.getPurchaseByShop()
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/lamy/PurchaseBehavior/PurchaseByShop.vue